import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from 'infrastructure/common/model/api.query';

@Injectable({ providedIn: 'root' })
export class FetchUserDaysUntilNextLevelUpCountApiQuery extends ApiQuery<
	number,
	void
> {
	client = 'statistics';
	document = gql`
		query FetchUserDaysUntilNextLevelUpCount {
			fetchUserDaysUntilNextLevelUpCount
		}
	`;
	method = 'fetchUserDaysUntilNextLevelUpCount';
}
